/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import type { SVGProps } from 'react';

export type IllustrationSizeVariants =
  | 'small'
  | 'medium'
  | 'large'
  | 'xlarge'
  | 'xxlarge'
  | 'xxxlarge'
  | 'xxxxlarge';
export type IllustrationProps = {
  width?: number | string;
  height?: number | string;
  size?: IllustrationSizeVariants;
};
const IllustrationEmptyStateArticle = ({
  size = 'medium',
  width,
  height,
  ...props
}: IllustrationProps) => {
  let presetWidth: string | undefined;
  let presetHeight: string | undefined;
  const presets = {
    small: '48px',
    medium: '68px',
    large: '92px',
    xlarge: '122px',
    xxlarge: '156px',
    xxxlarge: '194px',
    xxxxlarge: '236px',
  };
  if (size) {
    presetWidth = presets[size];
    presetHeight = presets[size];
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 68 68"
      data-xds="IllustrationEmptyStateArticle"
      height={height || presetHeight}
      role="presentation"
      width={width || presetWidth}
      {...props}
    >
      <path
        fill="var(--xdlColorIllustrationBackground)"
        fillOpacity={0.01}
        d="M58.64 52.72V38.54L62 5.59l-3.36-.34V2.28H29.51L12.62.56l-.17 1.72H9.01v33.74L6.32 62.37l2.69.27v1.77h17.34L55.7 67.4l1.19-11.68 1.17-1.16.58-.59v-.01l.37-.36z"
      />
      <path fill="#F4F4F5" d="M47.38 62.41H11.01V4.28h45.63v48.86z" />
      <path
        fill="#BCC9D1"
        d="M52.82 12.08H15.15v20.61h37.67zM31.84 62.41H15.15V51.04h16.69z"
      />
      <path
        fill="#8A9DA6"
        d="M47.4 62.36v-9.24h9.24s.02.01 0 .02l-9.22 9.22z"
      />
      <path
        fill="#5E737D"
        d="M40.48 7.71H26.49v1h13.99zM32.59 46.67H14.6v1h17.99zM32.59 43H14.6v1h17.99zM32.59 35.66H14.6v1h17.99zM32.59 39.33H14.6v1h17.99zM53.3 46.67H35.31v1H53.3zM53.3 43H35.31v1H53.3zM53.3 35.66H35.31v1H53.3zM53.3 39.33H35.31v1H53.3zM53.3 50.44H35.31v1H53.3zM14.65 11.58v21.61h38.67V11.58zm1 1h36.67v15.25l-5.65-5.65-6.49 6.49-11.25-11.25-13.27 13.27V12.58zm0 19.53 13.27-13.27 11.25 11.25 6.49-6.49 5.58 5.58.08-.08v3.1H15.65z"
      />
      <path
        fill="#5E737D"
        d="M39.56 22.45c-1.94 0-3.51-1.58-3.51-3.51s1.58-3.51 3.51-3.51 3.51 1.58 3.51 3.51-1.58 3.51-3.51 3.51m0-6.02c-1.38 0-2.51 1.13-2.51 2.51s1.13 2.51 2.51 2.51 2.51-1.13 2.51-2.51-1.13-2.51-2.51-2.51"
      />
      <path
        fill="#5E737D"
        d="m57.14 33.53 2.67-26.16-2.67-.27V3.77H24.5L14.41 2.74l-.1 1.03h-3.8v37.25L8.52 60.57l1.99.2v2.13h20.85l22.56 2.3.98-9.61 2.25-2.25.09-.1-.09-.22v-19.5zm-25.8 28.38H15.65V51.54h15.69zm16.56-.73v-7.56h7.56zm-1.01-8.56v1.49H35.3v1h11.59v2.67H35.3v1h11.59v3.13H32.33V50.54H14.65v11.37h-3.14V4.78h44.64v47.84z"
      />
    </svg>
  );
};
export default IllustrationEmptyStateArticle;
